import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import useI18n from '../../hooks/use-i18n';

import '../../styles/referral/cta-banner.scss';

const CtaBanner = (props) => {
  const { referrerName, referralAmount, country } = props;

  const [isMobile, setIsMobile] = useState(false);

  const i18n = useI18n();

  const { t } = i18n;

  useEffect(() => {
    setIsMobile(window.innerWidth < 672);
  }, []);

  return (
    <section className={`banner-section ${country === 'vn' ? 'vn_banner-section' : ''}`}>
      <div className="banner-left-col">
        <h1
          data-key="referral:cta_section::title"
          data-lokalise=""
        >
          {referrerName ? t('referral.cta_section.title_with_name',
            { referrer_name: referrerName, referred_amount: referralAmount?.referredAmount })
            : t('referral.cta_section.title_without_name',
              { referred_amount: referralAmount?.referredAmount })}
        </h1>
        <p data-key="referral::cta_section::description" data-lokalise="">
          {t('referral.cta_section.description')}
        </p>
        <a href="#" data-key="referral::cta_section::button_text" data-lokalise="">
          {t('referral.cta_section.button_text', { referred_amount: referralAmount?.referredAmount })}
        </a>
      </div>
      <div className="banner-right-col">
        <img
          src={`${country === 'vn'
            ? '/img/referral/revamp/vn-referrals_'
            : '/img/referral/revamp/referrals_'}${isMobile ? 'mobile' : 'desktop'}.svg`}
          alt="banner-background"
        />
      </div>
    </section>
  );
};

export default CtaBanner;

CtaBanner.propTypes = {
  referrerName: PropTypes.string.isRequired,
  referralAmount: PropTypes.shape({
    referrerAmount: PropTypes.string,
    referredAmount: PropTypes.string
  }).isRequired,
  country: PropTypes.string.isRequired
};
